import { georgeMediaArray } from './georgeMedia'
import { georgeBio } from './georgeBios'
import { elaineProfileReviewHinge, jerryProfileReviewBumble, kramerProfileReviewTinder } from './georgeProfileReviews'

export const georgeDatingProfileHinge = {
  _id: 'georgeDatingProfileHingeId',
  userId: 'georgeUserId',
  email: 'george@email.com',
  type: 'hinge',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: georgeMediaArray[16]._id,
      mediaItemURL: georgeMediaArray[16].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: georgeMediaArray[16].type,
      caption: georgeMediaArray[16].captions[0],
      subcaption: georgeMediaArray[16].subcaptions[2],
    },
    {
      mediaItemId: georgeMediaArray[11]._id,
      mediaItemURL: georgeMediaArray[11].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: georgeMediaArray[11].type,
      caption: georgeMediaArray[11].captions[1],
      subcaption: georgeMediaArray[11].subcaptions[1],
    },
    {
      mediaItemId: georgeMediaArray[12]._id,
      mediaItemURL: georgeMediaArray[12].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: georgeMediaArray[12].type,
      caption: georgeMediaArray[12].captions[2],
      subcaption: georgeMediaArray[12].subcaptions[0],
    },
    {
      mediaItemId: georgeMediaArray[10]._id,
      mediaItemURL: georgeMediaArray[10].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: georgeMediaArray[10].type,
      caption: georgeMediaArray[10].captions[2],
      subcaption: georgeMediaArray[10].subcaptions[2],
    },
    {
      mediaItemId: georgeMediaArray[13]._id,
      mediaItemURL: georgeMediaArray[13].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: georgeMediaArray[13].type,
      caption: georgeMediaArray[13].captions[0],
      subcaption: georgeMediaArray[13].subcaptions[2],
    },
    {
      mediaItemId: georgeMediaArray[17]._id,
      mediaItemURL: georgeMediaArray[17].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: georgeMediaArray[17].type,
      caption: georgeMediaArray[17].captions[1],
      subcaption: georgeMediaArray[17].subcaptions[2],
    }
  ],
  bio: {
    bioItemsId: georgeBio._id,
    vitalInfo: { ...georgeBio.vitalInfo },
    prompts: [
      { ...georgeBio.prompts[0] },
      { ...georgeBio.prompts[1] },
      { ...georgeBio.prompts[2] }
    ],
    aboutMe: '',
    hobbies: ['', '', '', '', ''],
  },
  profileReviews: [
    { ...elaineProfileReviewHinge }
  ],
  mediaItems: [ ...georgeMediaArray ],
  bioItems: { ...georgeBio },
}

export const georgeDatingProfileBumble = {
  _id: 'georgeDatingProfileBumbleId',
  userId: 'georgeUserId',
  email: 'george@email.com',
  type: 'bumble',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: georgeMediaArray[16]._id,
      mediaItemURL: georgeMediaArray[16].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: georgeMediaArray[16].type,
      caption: georgeMediaArray[16].captions[0],
      subcaption: georgeMediaArray[16].subcaptions[2],
    },
    {
      mediaItemId: georgeMediaArray[11]._id,
      mediaItemURL: georgeMediaArray[11].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: georgeMediaArray[11].type,
      caption: georgeMediaArray[11].captions[1],
      subcaption: georgeMediaArray[11].subcaptions[1],
    },
    {
      mediaItemId: georgeMediaArray[12]._id,
      mediaItemURL: georgeMediaArray[12].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: georgeMediaArray[12].type,
      caption: georgeMediaArray[12].captions[2],
      subcaption: georgeMediaArray[12].subcaptions[0],
    },
    {
      mediaItemId: georgeMediaArray[10]._id,
      mediaItemURL: georgeMediaArray[10].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: georgeMediaArray[10].type,
      caption: georgeMediaArray[10].captions[2],
      subcaption: georgeMediaArray[10].subcaptions[2],
    },
    {
      mediaItemId: georgeMediaArray[13]._id,
      mediaItemURL: georgeMediaArray[13].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: georgeMediaArray[13].type,
      caption: georgeMediaArray[13].captions[0],
      subcaption: georgeMediaArray[13].subcaptions[2],
    },
    {
      mediaItemId: georgeMediaArray[17]._id,
      mediaItemURL: georgeMediaArray[17].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: georgeMediaArray[17].type,
      caption: georgeMediaArray[17].captions[1],
      subcaption: georgeMediaArray[17].subcaptions[2],
    }
  ],
  bio: {
    bioItemsId: georgeBio._id,
    vitalInfo: { ...georgeBio.vitalInfo },
    prompts: [
      { ...georgeBio.prompts[0] },
      { ...georgeBio.prompts[1] },
      { ...georgeBio.prompts[2] }
    ],
    aboutMe: georgeBio.aboutMe[0],
    hobbies: [georgeBio.hobbies[0], georgeBio.hobbies[1], georgeBio.hobbies[2], georgeBio.hobbies[3], georgeBio.hobbies[4] ],
  },
  profileReviews: [
    { ...jerryProfileReviewBumble }
  ],
  mediaItems: [ ...georgeMediaArray ],
  bioItems: { ...georgeBio },
}

export const georgeDatingProfileTinder = {
  _id: 'georgeDatingProfileTinderId',
  userId: 'georgeUserId',
  email: 'george@email.com',
  type: 'tinder',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: georgeMediaArray[16]._id,
      mediaItemURL: georgeMediaArray[16].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: georgeMediaArray[16].type,
      caption: georgeMediaArray[16].captions[0],
      subcaption: georgeMediaArray[16].subcaptions[2],
    },
    {
      mediaItemId: georgeMediaArray[11]._id,
      mediaItemURL: georgeMediaArray[11].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: georgeMediaArray[11].type,
      caption: georgeMediaArray[11].captions[1],
      subcaption: georgeMediaArray[11].subcaptions[1],
    },
    {
      mediaItemId: georgeMediaArray[12]._id,
      mediaItemURL: georgeMediaArray[12].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: georgeMediaArray[12].type,
      caption: georgeMediaArray[12].captions[2],
      subcaption: georgeMediaArray[12].subcaptions[0],
    },
    {
      mediaItemId: georgeMediaArray[10]._id,
      mediaItemURL: georgeMediaArray[10].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: georgeMediaArray[10].type,
      caption: georgeMediaArray[10].captions[2],
      subcaption: georgeMediaArray[10].subcaptions[2],
    },
    {
      mediaItemId: georgeMediaArray[13]._id,
      mediaItemURL: georgeMediaArray[13].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: georgeMediaArray[13].type,
      caption: georgeMediaArray[13].captions[0],
      subcaption: georgeMediaArray[13].subcaptions[2],
    },
    {
      mediaItemId: georgeMediaArray[17]._id,
      mediaItemURL: georgeMediaArray[17].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: georgeMediaArray[17].type,
      caption: georgeMediaArray[17].captions[1],
      subcaption: georgeMediaArray[17].subcaptions[2],
    }
  ],
  bio: {
    bioItemsId: georgeBio._id,
    vitalInfo: { ...georgeBio.vitalInfo },
    prompts: [
      { ...georgeBio.prompts[0] },
      { ...georgeBio.prompts[1] },
      { ...georgeBio.prompts[2] }
    ],
    aboutMe: georgeBio.aboutMe[0],
    hobbies: [georgeBio.hobbies[0], georgeBio.hobbies[1], georgeBio.hobbies[2], georgeBio.hobbies[3], georgeBio.hobbies[4] ],
  },
  profileReviews: [
    { ...kramerProfileReviewTinder }
  ],
  mediaItems: [ ...georgeMediaArray ],
  bioItems: { ...georgeBio },
}